import { LinkIcon, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Rendered when the user has zero links.
 * Note: the backend seeds one demo link on first startup, so this really
 * only appears after the user has deleted everything.
 */
export default function EmptyState({ onAdd }) {
  return (
    <div
      className="flex flex-col items-center justify-center gap-4 rounded-xl border border-dashed border-white/10 bg-white/[0.015] px-6 py-12 text-center"
      data-testid="empty-state"
    >
      <div
        className="flex h-14 w-14 items-center justify-center rounded-2xl border border-accent/30 bg-accent/10 text-accent"
        aria-hidden
      >
        <LinkIcon className="h-6 w-6" />
      </div>
      <div className="flex flex-col gap-1">
        <h2 className="font-display text-lg font-semibold text-text-main">
          No links yet
        </h2>
        <p className="max-w-sm text-sm text-text-muted">
          Add your first referral link and RefClick will keep count for you
          every day. Dates roll over at midnight <span className="font-mono-num">Asia/Dhaka</span>.
        </p>
      </div>
      <Button
        type="button"
        onClick={onAdd}
        data-testid="empty-state-add-btn"
        className="gap-2 border border-accent/40 bg-accent/15 text-accent hover:bg-accent/25"
      >
        <Sparkles className="h-4 w-4" /> Add your first link
      </Button>
    </div>
  );
}
